/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { getScrollParent } from "./getScrollParent";
import { getOwnerWindow } from "./getOwnerWindow";
import { isElementScrollable } from "./isElementScrollable";
import { getParentNode } from "./getParentNode";

export function getScrollableParents(
	element: HTMLElement | Node,
	scrollableParents: HTMLElement[] = []
): Array<Element | Window> {
	const scrollParent = getScrollParent(element);
	const parentIsBody = scrollParent === element.ownerDocument?.body;
	const win = getOwnerWindow(scrollParent);
	const target = parentIsBody
		? [ win, ...(isElementScrollable(scrollParent) ? [ scrollParent ] : []) ]
		: [ scrollParent ];

	const updatedList = [ ...scrollableParents, ...target ];

	return parentIsBody
		? updatedList
		: [ ...updatedList, ...getScrollableParents(getParentNode(scrollParent)) ];
}
